import { render } from "./IconWasteType.vue?vue&type=template&id=800401ac"
import script from "./IconWasteType.vue?vue&type=script&lang=js"
export * from "./IconWasteType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__